import { Button, Paper, Stack, Typography } from '@mui/material'
import { getPxAsRem } from 'shared/utils'
import { type ReactNode } from 'react'

interface FilterSidebarProps {
    hasActiveFilters: boolean
    onClearFilters: () => void
    children: ReactNode
}

export function FilterSidebar({
    hasActiveFilters,
    onClearFilters,
    children,
}: FilterSidebarProps) {
    return (
        <Stack
            component={Paper}
            alignSelf="flex-start"
            flex={`0 0 ${getPxAsRem(340)}`}
            maxHeight="100%"
            maxWidth={getPxAsRem(340)}
        >
            <Stack
                direction="row"
                borderBottom={1}
                borderColor="divider"
                padding={getPxAsRem(16)}
                alignItems="center"
                justifyContent="space-between"
            >
                <Typography variant="h4">Filters</Typography>

                <Button
                    onClick={onClearFilters}
                    variant="text"
                    size="small"
                    disabled={!hasActiveFilters}
                >
                    Clear
                </Button>
            </Stack>

            {children}
        </Stack>
    )
}
